import React from "react"
import cn from "classnames"
import CheckedIcon from "./assets/icons/checked.svg"
import UncheckedIcon from "./assets/icons/unchecked.svg"
import styles from "./styles.css"

/**
 * Temporary solution while there is no such component in uikit
 */

/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
export default ({ input, meta: { valid }, ...rest }) => (
  <label className={styles.Radio}>
    <input
      className={styles[`hidden-input`]}
      {...input}
      {...rest}
      type="radio"
    />
    <div
      className={cn(styles[`control-indicator`], {
        [styles.invalid]: input ? !valid : false,
      })}
    >
      {input.checked ? <CheckedIcon /> : <UncheckedIcon />}
    </div>
  </label>
)
